// removed by extract-text-webpack-plugin
module.exports = {"podRow":"CwPodRow-podRow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpod/CwPodRow.scss
// module id = 380
// module chunks = 0